<template>
  <!-- 商品管理————组件 -->
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :fullscreen="true" top="1vh" width="92%"
    custom-class="goods-dialog" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="goods-dialog-body">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="goods-form">
        <div class="goods-layout">
          <!-- 左侧：基础信息、销售限制、区域费用 -->
          <div class="goods-main">
            <section class="form-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>商品信息</span>
              </div>

              <div class="form-grid form-grid-2">
                <el-form-item label="商品名称" prop="name" class="grid-span-2">
                  <el-input v-model="form.name" autocomplete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>

                <el-form-item label="商品线路" prop="kor_type">
                  <el-select v-model="form.kor_type" style="width: 100%" placeholder="请选择" @change="kor_type_change">
                    <el-option v-for="item in countryList" :key="item.type" :label="item.name"
                      :value="item.type"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="商品原产国" prop="origin">
                  <el-select v-model="form.origin" style="width: 100%" placeholder="请选择">
                    <el-option v-for="(item, index) in origin_list[0]" :key="index" :label="item"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="商品分类" prop="cid">
                  <el-cascader v-model="form.cid" :props="props" :options="typeList" style="width: 100%"></el-cascader>
                </el-form-item>

                <el-form-item label="韩国链接" prop="link">
                  <el-input v-model.trim="form.link" autocomplete="off" placeholder="请输入商品链接"
                    type="textarea"></el-input>
                </el-form-item>

                <el-form-item label="税金" prop="tax">
                  <el-input v-model.trim="form.tax" autocomplete="off" maxlength="8" show-word-limit placeholder="请输入税金"
                    @input="handleInput"></el-input>
                </el-form-item>

                <el-form-item v-if="isShow" label="添加时间" prop="update_time">
                  <el-input v-model.trim="form.update_time" :disabled="true" autocomplete="off"></el-input>
                </el-form-item>
              </div>
            </section>

            <section class="form-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>销售限制</span>
              </div>

              <div class="form-grid form-grid-2">
                <el-form-item label="自动下架" prop="removal_time">
                  <el-date-picker v-model="form.removal_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间" style="width: 100%"></el-date-picker>
                </el-form-item>

                <el-form-item label="每人限购">
                  <el-input v-model.trim="form.single_user_max" autocomplete="off" maxlength="8" show-word-limit>
                    <span slot="append">件</span>
                  </el-input>
                </el-form-item>

                <el-form-item label="每单限购">
                  <el-input v-model.trim="form.per_order_limit" autocomplete="off" maxlength="8" show-word-limit>
                    <span slot="append">件</span>
                  </el-input>
                </el-form-item>

                <el-form-item label="偏远省份" class="grid-span-2">
                  <el-select v-model="form.remote_city" multiple placeholder="请选择偏远省份" style="width: 100%">
                    <el-option v-for="item in provinceList" :key="item.code" :label="item.name"
                      :value="item.code"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="偏远运费" class="grid-span-2">
                  <el-input v-model.trim="form.remote_price" autocomplete="off" maxlength="8" show-word-limit
                    placeholder="请输入偏远地区加收费用" @input="handleInput">
                    <span slot="append">元</span>
                  </el-input>
                </el-form-item>
              </div>
            </section>

            <section class="form-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>商品状态</span>
              </div>

              <div class="status-grid">
                <el-form-item label="是否置顶" prop="top">
                  <el-radio-group v-model="form.top">
                    <el-radio :label="0">不置顶</el-radio>
                    <el-radio :label="1">置顶</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="是否推荐" prop="recommend">
                  <el-radio-group v-model="form.recommend">
                    <el-radio :label="0">不推荐</el-radio>
                    <el-radio :label="1">推荐</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="商品类型" prop="is_supplement">
                  <el-radio-group v-model="form.is_supplement">
                    <el-radio :label="0">普通商品</el-radio>
                    <el-radio :label="1">补价商品</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </section>
          </div>

          <!-- 右侧：图片与详情 -->
          <div class="goods-side">
            <section class="form-section media-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>商品图片</span>
              </div>

              <el-form-item label-width="0" prop="pic" class="no-label-item">
                <uploadFile :limit="50" :img-list-string="form.pic" @fileChange="uploadChange($event, 'pic')" />
                <div class="upload-tip">
                  <i class="el-icon-info"></i>
                  上传图片限制最多 50 张
                  <!-- 建议上传 1:1 或 3:2 图片，最多 50 张 -->
                </div>
              </el-form-item>
            </section>

            <section class="form-section detail-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>商品详情文本</span>
              </div>

              <el-form-item label-width="0" prop="content" class="no-label-item">
                <div class="editor-wrapper">
                  <quill-editor ref="myQuillEditor" v-model="form.content" :options="editorOption"
                    @change="onEditorChange($event)" />
                </div>
              </el-form-item>
            </section>

            <section class="form-section">
              <div class="section-title">
                <span class="section-bar"></span>
                <span>详情图片</span>
              </div>

              <el-form-item label-width="0" prop="content_pic" class="no-label-item">
                <uploadFile :limit="20" :img-list-string="form.content_pic"
                  @fileChange="uploadChange($event, 'content_pic')" />
              </el-form-item>
            </section>
          </div>
        </div>

        <!-- SKU / 规格：独占整行，避免和基础信息挤在一起 -->
        <section class="form-section specification-section">
          <div class="section-title">
            <span class="section-bar"></span>
            <span>商品规格</span>
            <div class="section-actions">
              <el-button size="mini" @click="addSpecifications">
                <i class="el-icon-plus"></i> 添加规格
              </el-button>
              <el-button type="primary" size="mini" :loading="skuLoading" @click="getSkuList">
                生成SKU列表
              </el-button>
            </div>
          </div>

          <div class="spec-list">
            <div v-for="(item, index) in SpecificationsList" :key="index" class="guige_item">
              <div class="guige_item_top">
                <div class="spec-name">
                  <span class="spec-index">{{ index + 1 }}</span>
                  <el-input v-model="item.name" placeholder="请输入规格名，如：颜色 / 尺码" autocomplete="off"
                    @input="changeInput_sku($event, index)"></el-input>
                  <el-button type="primary" plain @click="addSpecifications_item(index)" style="margin-left: 20px;">
                    <i class="el-icon-plus"></i> 添加规格项
                  </el-button>
                </div>
                <div class="spec-actions">

                  <el-button type="text" class="danger-text" @click="delSpecifications(index)">
                    删除
                  </el-button>
                </div>
              </div>

              <div class="guige_item_bottom">
                <el-input v-for="(ite, ind) in item.item" :key="ind" v-model="ite.text" class="spec-value-input"
                  placeholder="请输入规格项" autocomplete="off" @input="changeInput($event, index, ind)">
                  <el-button slot="append" icon="el-icon-close" @click="delSpecifications_item(index, ind)"></el-button>
                </el-input>
                <span v-if="item.item.length === 0" class="empty-spec">
                  暂无规格项，请点击“添加规格项”
                </span>
              </div>
            </div>
          </div>

          <el-empty v-if="SpecificationsList.length === 0" :image-size="60" description="暂未添加商品规格"></el-empty>
        </section>

        <section v-if="skuList.length > 0" class="form-section sku-section">
          <div class="section-title">
            <span class="section-bar"></span>
            <span>SKU列表</span>
            <span class="section-desc">可直接编辑价格、库存、限购等信息</span>
            <el-input v-model="queryForm.barcode" :clearable="true" placeholder="输入修改后备案号"
              style="width:300px;margin-left: 10px;" />
            <el-input v-model="queryForm.price" :clearable="true" placeholder="输入修改后价格"
              style="width:150px;margin-left: 10px;" />
            <el-input v-model="queryForm.stock" :clearable="true" placeholder="输入修改后库存"
              style="width:150px;margin-left: 10px;" />
            <el-input v-model="queryForm.max_buy" :clearable="true" placeholder="输入修改后限购"
              style="width:150px;margin-left: 10px;" />
            <el-button icon="el-icon-edit" type="warning" @click.stop.prevent="modify"
              style="border-radius: 8px;margin-left: 10px;">
              批量修改
            </el-button>
          </div>

          <div class="sku-table-wrapper">
            <el-table :data="skuList" border stripe style="width: 100%">
              <el-table-column align="left" prop="sku" label="规格名" min-width="180"></el-table-column>

              <el-table-column align="center" label="规格图" min-width="130">
                <template slot-scope="scope">
                  <div class="sku-pic-cell">
                    <uploadFile :limit="1" maxlength="15" show-word-limit :img-list-string="scope.row.pic"
                      @fileChange="skuListPicChange($event, scope.$index)" />
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="备案号" min-width="150">
                <template slot-scope="{ row }">
                  <el-input v-model="row.barcode" size="small" @change="oneClickModify(row)"></el-input>
                </template>
              </el-table-column>

              <el-table-column align="center" label="价格" min-width="140">
                <template slot-scope="{ row }">
                  <el-input v-model="row.price" size="small" maxlength="10" show-word-limit
                    @input="(e) => { row.price = $geShi(e) }" @change="oneClickModify(row)">
                    <span slot="append">元</span>
                  </el-input>
                </template>
              </el-table-column>

              <el-table-column align="center" label="库存" min-width="130">
                <template slot-scope="{ row }">
                  <el-input v-model="row.stock" size="small" maxlength="10" show-word-limit
                    @change="oneClickModify(row)">
                    <span slot="append">件</span>
                  </el-input>
                </template>
              </el-table-column>

              <el-table-column align="center" label="限购" min-width="130">
                <template slot-scope="{ row }">
                  <el-input v-model="row.max_buy" size="small" maxlength="10" show-word-limit
                    @change="oneClickModify(row)">
                    <span slot="append">件</span>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form>

      <div v-if="skuList.length > 0" class="pagination-wrap">
        <el-pagination :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]"
          :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
          @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <!-- <el-button type="primary" v-if="!isShow" @click="close">确定</el-button> -->
      <el-button type="primary" :loading="saveLoading" @click="putProductOnShelf">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  goodsUpdate,
  goods_info,
  GoodsCate_list,
  Index_country_list,
  Index_origin,
  getCityList,
  goodsSkuList,
  goods_spec,
  goodsSkuUpdate,
  goods_price,
  goodsSkuDel
} from '@/api/xgcApi'
import {
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadFileSpecification'
import {
  goodsAdd
} from '../../../api/xgcApi'
import exoprt_file from '@/utils/expor_file' // 导出excel文件
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{
    header: 1,
  },
  {
    header: 2,
  },
  ], // custom button values
  [{
    list: 'ordered',
  },
  {
    list: 'bullet',
  },
  ],
  [{
    script: 'sub',
  },
  {
    script: 'super',
  },
  ], // superscript/subscript
  [{
    indent: '-1',
  },
  {
    indent: '+1',
  },
  ], // outdent/indent
  [{
    direction: 'rtl',
  },], // text direction

  [{
    size: ['small', false, 'large', 'huge'],
  },], // custom dropdown
  [{
    header: [1, 2, 3, 4, 5, 6, false],
  },],

  [{
    color: [],
  },
  {
    background: [],
  },
  ], // dropdown with defaults from theme
  [{
    font: [],
  },],
  [{
    align: [],
  },],
  ['clean'], // remove formatting button
]

export default {
  name: 'UserManagementEdit',
  components: {
    uploadFile,
  },
  props: {
    // typeList: {
    //   type: Array,
    //   default: [],
    // },
  },
  data() {
    return {
      skuLoading: false,
      provinceList: [],
      saveLoading: false,
      origin_list: [],//原产国列表
      skuList_copy: [], //sku列表备份
      typeList: [],
      countryList: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'sub'
      },
      value: '',
      total: 0,
      layout: 'total, sizes, prev, pager, next, jumper',
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              // 重写点击组件上的图片按钮要执行的代码
              image: function (value) {
                document
                  .querySelector('.quill-upload .el-upload__input')
                  .click()
              },
            },
          },
        },
      },
      upUrl: '/index/index/file', //上传图片的接口
      editor: null,
      // 规格列表
      SpecificationsList: [
        // {
        //   name:'内存',
        //   item:[{text:'128GB'} , {text:'256GB'}  , {text:'1TB'}]
        // },
        // {
        //   name:'颜色',
        //   item:[{text:'白色'} , {text:'粉色'} , {text:'远山蓝'}]
        // }
      ],
      skuList: [], //规格列表
      form: {
        single_user_max: 0,
        per_order_limit: 0,
        b_type_id: null,
        removal_time: '',
        link: '',
        tax: '',
        kor_type: 0,
        type: 2,
        origin: 'KR',
        top: 0,
        recommend: 0,
        is_supplement: 0,
        remote_city: '', //偏远省份
        remote_price: '', //偏远地区加收费用
        status: 1
      },
      dialogFormVisible: false,
      rules: {
        origin: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入原产国',
        }],
        kor_type: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择线路',
        },],
        cid: [{
          required: true,
          trigger: 'change',
          message: '请选择商品分类'
        },
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value == 0) {
              callback(new Error('请选择商品分类'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
        },
        ],
        tax: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入税金',
        }],
        top: [
          {
            required: true,
            trigger: ['blur', 'change'],
            message: '请输入商品名称',
          }
        ],
        name: [{
          required: true,
          trigger: 'blur',
          message: '请输入商品名称',
        },],

        price: [{
          required: true,
          trigger: 'blur',
          message: '请输入商品金额',
        },],
        // type: [
        //   { required: true, trigger: 'change', message: '请选择商品类型' },
        // ],
        // pic: [{ required: true, trigger: 'blur', message: '请选择商品图片' }],
      },
      title: '',
      isShow: false,
      statusList: [
        {
          value: 1,
          label: '补价商品',
        },
        {
          value: 2,
          label: '普通商品',
        },
      ],
      queryForm: {
        goods_id: '',
        page: 1,
        limit: 20,
        name: '',
        kor_type: '0',
        price: '', //价格
        stock: '', //库存
        barcode: '', //备案号
        max_buy: '' //限购
      },

    }
  },
  methods: {
    // 弹窗初始化方法
    showEdit(row) {
      this.getProvinceList()//获取省份列表
      this.getTypelist() //商品分类
      this.getProductRoute()
      if (!row) {
        this.queryForm.goods_id = ''
        Index_origin({}).then(req => {
          this.origin_list = req.data
          this.title = '添加'
          this.isShow = false
          this.form.pic = ''
          this.value = ''

          this.dialogFormVisible = true
        })
      } else {
        this.title = '编辑'
        this.isShow = true
        this.queryForm.goods_id = row.id
        Index_origin({}).then(req => {
          this.origin_list = req.data
          goods_info({ goods_id: row.id }).then(res => {
            const data = res.data
            const toNumberArray = (val) => {
              if (val == null || val === '') return []
              const arr = Array.isArray(val) ? val : String(val).split(',')
              return arr.map(Number)
            }

            data.cid = toNumberArray(data.cid)
            data.remote_city = toNumberArray(data.remote_city)
            this.value = data.content

            // 规格项处理：item 从 JSON 字符串转成 [{text}]
            data.spec.forEach((ite, index) => {
              const arr = JSON.parse(ite.item)
              data.spec[index].item = arr.map(text => ({ text }))
            })

            this.fetchData()
            this.SpecificationsList = data.spec
            this.form = data
            this.dialogFormVisible = true
          })
          // --------------------
        })

      }
    },

    //单条数据修改
    oneClickModify(e) {
      if (typeof (e.sku) === 'string') {
        e.sku = e.sku.split(",")
      }
      var list = []
      list.push(e)
      var date = {
        id: e.gid,
        type: 0, //0表示没修改组合 1修改组合清除下面sku
        spec_list: list
      }
      this.listLoading = true
      goodsSkuUpdate(date).then(res => {
        this.listLoading = false
        this.$message.success('修改成功')
      }).catch(err => {
        this.listLoading = false
      })
    },
    kor_type_change() {
      this.form.cid = null
      this.form.bid = null
      this.form.b_type_id = null
      this.getTypelist()
    },
    getProvinceList() {
      getCityList({ pid: 0 }).then(res => {
        this.provinceList = res.data
      })
    },
    getTypelist() {
      var data = {
        page: 1,
        kor_type: this.form.kor_type
      }
      this.listLoading = true
      GoodsCate_list(data)
        .then((res) => {
          this.typeList = res.data
        })
        .catch((err) => {
          this.listLoading = false
        })
    },
    // 获取商品线路
    getProductRoute() {
      var data = {}
      Index_country_list(data).then(res => {
        this.countryList = res.data
      })
    },
    // 将-字符换成_
    changeInput_sku(e, index) {
      this.SpecificationsList[index].name = this.SpecificationsList[
        index
      ].name.replace(/-/g, '_')
    },
    // 将-字符换成_
    changeInput(e, index, ind) {
      this.SpecificationsList[index].item[ind].text = this.SpecificationsList[
        index
      ].item[ind].text.replace(/-/g, '_')
    },
    // t添加规格项
    addSpecifications() {
      var item = {
        name: '',
        item: [],
      }
      this.SpecificationsList.push(item)
    },
    // 上传、修改图片
    skuListPicChange(e, index) {
      if (e.length > 0) {
        this.skuList[index].pic = e[0]
      } else {
        this.skuList[index].pic = ''
      }
      this.oneClickModify(this.skuList[index])
    },
    // 添加规格项
    addSpecifications_item(index) {
      var child = {
        text: '',
      }
      this.SpecificationsList[index].item.push(child)
    },
    // 删除规格
    delSpecifications(index) {
      this.SpecificationsList.splice(index, 1)

      // goodsSkuDel(id).then(res=>{

      // })


    },
    // 删除规格项
    delSpecifications_item(index, ind) {
      this.SpecificationsList[index].item.splice(ind, 1)
    },
    // 生成SKU列表
    getSkuList() {
      if (this.skuLoading) return          // 防止重复点击

      // 1. 校验规格列表非空
      if (this.SpecificationsList.length === 0) {
        this.$message.warning('请最少添加一个规格')
        return
      }

      // 2. 校验规格名称和规格项（用 for 循环才能中断）
      for (let i = 0; i < this.SpecificationsList.length; i++) {
        const item = this.SpecificationsList[i]
        if (!item.name) {
          this.$message.warning('请填写规格名称')
          return
        }
        if (item.item.length === 0) {
          this.$message.warning('规格项不能为空')
          return
        }
      }

      // 3. 深拷贝并转换结构
      const arr1 = JSON.parse(JSON.stringify(this.SpecificationsList))
      arr1.forEach(item => {
        item.item = item.item.map(i => i.text)
      })

      // 4. 校验通过后才开 loading
      this.skuLoading = true

      // 5. 根据是否有 goods_id 走新增或修改，等异步完成再关 loading
      const task = this.queryForm.goods_id
        ? this.submitSpecifications(arr1, this.queryForm.goods_id)
        : this.save(arr1)

      Promise.resolve(task)
        .catch(() => { })      // 错误可在这里统一处理，或交给内部
        .finally(() => {
          this.skuLoading = false
        })
    },

    // 提交规格
    submitSpecifications(e, id) {
      const date = {
        goods_id: id,
        spec: e
      }
      // 关键：return 出去
      return goods_spec(date).then(res => {
        this.$message.success(res.msg)
        this.queryForm.goods_id = id
        this.fetchData()
        return res
      })
    },
    // 批量修改
    modify() {
      var data = {
        "goods_id": this.queryForm.goods_id, //商品id
        "kor_type": "0",
        "price": this.queryForm.price, //价格
        "stock": this.queryForm.stock, //库存
        "barcode": this.queryForm.barcode, //备案号
        "max_buy": this.queryForm.max_buy //限购
      }
      // this.listLoading = true
      goods_price(data)
        .then((res) => {
          this.$message.success('修改成功')
          this.queryForm.page = 1
          this.fetchData()
        })
        .catch((err) => {
        })
      this.queryForm.price = ''
      this.queryForm.stock = ''
      this.queryForm.barcode = ''
      this.queryForm.max_buy = ''
    },

    /**
     *@name 富文本编辑器
     *@time 2024年4月23日15:01:58
     */
    // ---------------------------富文本编辑器开始--------------------------------------
    onEditorChange(e) { },
    upload(file) {
      // 图片上传
      file = file.file
      var data = {
        file: file,
      }
      var url = ''
      exoprt_file(this.upUrl, data).then((res) => {
        var pic = getUploadUrl + res
        let quill = this.$refs.myQuillEditor.quill
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', pic)
        // 调整光标到最后
        quill.setSelection(length + 1)
        // 调用编辑器的 insertEmbed 方法，插入URL
      })
    },
    handleInput() {
      // 移除非数字和非小数点字符，保留小数点
      this.form.tax = this.form.tax
        .replace(/[^\d.]/g, '')
        // 保留第一个小数点，移除其他小数点
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        // 移除前导零，但保留小数点前的单个零
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },
    // 上传图片
    uploadChange(e, key) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      this.form[key] = strurl
    },


    fetchData() {

      goodsSkuList(this.queryForm).then(res => {
        this.skuList = res.data.list
        this.total = res.data.count
      })

    },

    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },


    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.skuList = []
      this.SpecificationsList = []
      this.dialogFormVisible = false
      this.value = ''
    },



    putProductOnShelf() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.form.remote_city.length > 0 && (this.form.remote_price <= 0 || this.form.remote_price == '')) {
            this.$message.warning('请输入偏远地区运费价格')
            this.saveLoading = false
            return
          }
          // 添加
          if (this.isShow == false) {
            // 1. 校验规格列表非空
            if (this.SpecificationsList.length === 0) {
              this.$message.warning('请最少添加一个规格')
              this.saveLoading = false
              return
            }
            this.$baseMessage('添加成功', 'success')
            this.$emit('fetch-data')
            this.close()

          } else {
            // 修改
            var form = JSON.parse(JSON.stringify(this.form))
            delete form.spec
            form.remote_city = this.form.remote_city.join(',')
            this.$refs['form'].validate(async (valid) => {
              if (valid) {
                form.cid = this.form.cid.join(',')
                form.kor_type = String(this.form.kor_type)
                try {
                  const { msg } = await goodsUpdate(form)
                  this.saveLoading = false
                  this.$baseMessage(msg, 'success')
                  this.$emit('fetch-data')
                  this.close()
                } catch (error) {
                  // 错误处理
                  this.saveLoading = false
                }
              } else {
                this.saveLoading = false
                return false
              }
            })
          }
        } else {
          return false
          this.saveLoading = false
        }
      })
    },






    save(arr1) {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (!valid) {
            this.saveLoading = false
            return reject('validate fail')
          }

          this.saveLoading = true

          // 偏远地区运费校验
          if (this.form.remote_city.length > 0 && (this.form.remote_price <= 0 || this.form.remote_price == '')) {
            this.$message.warning('请输入偏远地区运费价格')
            this.saveLoading = false
            return reject('remote price empty')
          }

          // 组装 form
          const form = JSON.parse(JSON.stringify(this.form))
          form.cid = this.form.cid.join(',')
          if (form.remote_city) {
            form.remote_city = this.form.remote_city.join(',')
          }

          try {
            const res = await goodsAdd(form)
            // 等 SKU 提交完成，再关 loading
            await this.submitSpecifications(arr1, res.data)

            this.saveLoading = false
            resolve(res)
          } catch (err) {
            this.saveLoading = false
            this.$message.error(err?.msg || '保存失败')
            reject(err)
          }
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  margin: 0 auto;
}

/* ==================== 商品弹窗整体 ==================== */
::v-deep .goods-dialog {
  border-radius: 12px;
  overflow: hidden;
  background: #f5f7fa;
}

::v-deep .goods-dialog .el-dialog__header {
  height: 58px;
  box-sizing: border-box;
  padding: 0 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8edf3;
  background: #fff;
}

::v-deep .goods-dialog .el-dialog__title {
  color: #172b4d;
  font-size: 18px;
  font-weight: 600;
}

::v-deep .goods-dialog .el-dialog__headerbtn {
  top: 19px;
  right: 22px;
}

::v-deep .goods-dialog .el-dialog__body {
  padding: 16px 20px 20px;
  background: #f5f7fa;
}

::v-deep .goods-dialog .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #e8edf3;
  background: #fff;
}

/* 内容区独立滚动，底部操作栏始终可见 */
.goods-dialog-body {
  height: calc(94vh - 136px);
  min-height: 560px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  box-sizing: border-box;
}

.goods-dialog-body::-webkit-scrollbar {
  width: 6px;
}

.goods-dialog-body::-webkit-scrollbar-thumb {
  background: #cbd3df;
  border-radius: 6px;
}

.goods-dialog-body::-webkit-scrollbar-track {
  background: transparent;
}

/* ==================== 两栏布局 ==================== */
.goods-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(360px, 1fr);
  gap: 14px;
  align-items: start;
}

.goods-main,
.goods-side {
  min-width: 0;
}

/* ==================== 卡片/分组 ==================== */
.form-section {
  margin-bottom: 14px;
  padding: 16px 18px;
  box-sizing: border-box;
  border: 1px solid #e4e9f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(20, 40, 70, 0.02);
}

.section-title {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 24px;
  margin-bottom: 14px;
  padding-bottom: 11px;
  border-bottom: 1px solid #edf0f4;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 600;
}

.section-bar {
  width: 3px;
  height: 17px;
  margin-right: 9px;
  border-radius: 3px;
  background: #409eff;
}

.section-desc {
  margin-left: 12px;
  color: #8a96a8;
  font-size: 12px;
  font-weight: 400;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

/* ==================== 表单 ==================== */
.goods-form {
  color: #334155;
}

.form-grid {
  display: grid;
  gap: 2px 24px;
}

.form-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-span-2 {
  grid-column: 1 / -1;
}

::v-deep .goods-form .el-form-item {
  margin-bottom: 12px;
}

::v-deep .goods-form .el-form-item__label {
  color: #526173;
  font-size: 13px;
  line-height: 34px;
  padding-right: 12px;
}

::v-deep .goods-form .el-form-item__content {
  line-height: 34px;
}

::v-deep .goods-form .el-input__inner,
::v-deep .goods-form .el-select .el-input__inner,
::v-deep .goods-form .el-cascader .el-input__inner {
  height: 34px;
  line-height: 34px;
  border-color: #d9e0e8;
  border-radius: 5px;
  color: #253858;
  font-size: 13px;
}

::v-deep .goods-form .el-input__inner:hover,
::v-deep .goods-form .el-select .el-input__inner:hover {
  border-color: #aebaca;
}

::v-deep .goods-form .el-input__inner:focus {
  border-color: #409eff;
}

::v-deep .goods-form .el-input-group__append {
  padding: 0 10px;
  color: #7b8798;
  background: #f7f9fb;
  border-color: #d9e0e8;
}

::v-deep .goods-form .el-radio {
  margin-right: 18px;
}

::v-deep .goods-form .el-radio__label {
  color: #526173;
  font-size: 13px;
}

::v-deep .goods-form .el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background: #409eff;
}

::v-deep .goods-form .el-tag {
  border-radius: 3px;
}

/* 状态区域 */
.status-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 10px;
}

.status-grid .el-form-item {
  margin-bottom: 0;
}

/* ==================== 图片区域 ==================== */
.media-section {
  min-height: 248px;
}

.no-label-item {
  margin-bottom: 0 !important;
}

.upload-tip {
  margin-top: 8px;
  color: #8995a6;
  font-size: 12px;
  line-height: 18px;
}

.upload-tip i {
  margin-right: 4px;
  color: #9aa7b8;
}

/* uploadFile 组件内部样式兼容 */
::v-deep .media-section .el-upload,
::v-deep .media-section .avatar-uploader .el-upload {
  border-radius: 6px;
}

/* ==================== 富文本 ==================== */
.detail-section {
  padding-bottom: 14px;
}

.editor-wrapper {
  width: 100%;
  overflow: hidden;
  border: 1px solid #dfe5ec;
  border-radius: 6px;
}

::v-deep .ql-toolbar.ql-snow {
  padding: 5px 7px;
  border: 0;
  border-bottom: 1px solid #e7ebf0;
  background: #fafbfc;
}

::v-deep .ql-container.ql-snow {
  border: 0;
  height: 230px;
}

::v-deep .ql-editor {
  min-height: 190px;
  padding: 12px;
  color: #334155;
  font-size: 13px;
  line-height: 1.7;
}

/* ==================== 规格 ==================== */
.specification-section,
.sku-section {
  grid-column: 1 / -1;
}

.spec-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.guige_item {
  width: 100%;
  padding: 13px 14px;
  box-sizing: border-box;
  border: 1px solid #e3e8ef;
  border-radius: 7px;
  background: #fafbfd;
}

.guige_item:hover {
  border-color: #cbd7e6;
}

.guige_item_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.spec-name {
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 560px;
}

.spec-name .el-input {
  flex: 1;
}

.spec-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 9px;
  border-radius: 50%;
  color: #409eff;
  background: #ecf5ff;
  font-size: 12px;
  font-weight: 600;
}

.spec-actions {
  white-space: nowrap;
}

.spec-actions .el-button {
  padding: 4px 8px;
}

.danger-text {
  color: #f56c6c !important;
}

.guige_item_bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e3e8ef;
}

.spec-value-input {
  width: 190px;
}

.spec-value-input .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}

.empty-spec {
  color: #a0aaba;
  font-size: 12px;
}

::v-deep .el-empty {
  padding: 12px 0 4px;
}

/* ==================== SKU 表格 ==================== */
.sku-table-wrapper {
  overflow-x: auto;
}

::v-deep .sku-section .el-table {
  color: #334155;
  font-size: 13px;
}

::v-deep .sku-section .el-table th {
  color: #526173;
  background: #f7f9fb;
  font-weight: 600;
}

::v-deep .sku-section .el-table td,
::v-deep .sku-section .el-table th {
  padding: 8px 0;
}

.sku-pic-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ==================== 分页 & 底部 ==================== */
.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 2px 4px 4px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.dialog-footer .el-button {
  min-width: 82px;
  height: 34px;
  border-radius: 5px;
}

.dialog-footer .el-button--primary {
  box-shadow: 0 3px 8px rgba(64, 158, 255, 0.2);
}

/* ==================== 小屏/窄窗口适配 ==================== */
@media screen and (max-width: 1100px) {
  .goods-layout {
    grid-template-columns: 1fr;
  }

  .status-grid {
    grid-template-columns: 1fr;
  }

  .goods-side {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }

  .goods-side .form-section {
    margin-bottom: 0;
  }

  .goods-side .form-section:last-child {
    grid-column: 1 / -1;
  }
}

@media screen and (max-width: 760px) {
  .form-grid-2 {
    grid-template-columns: 1fr;
  }

  .grid-span-2 {
    grid-column: auto;
  }

  .goods-side {
    display: block;
  }

  .goods-side .form-section {
    margin-bottom: 14px;
  }

  ::v-deep .goods-dialog .el-dialog__body {
    padding: 10px;
  }

  .form-section {
    padding: 12px;
  }
}

/* 保留原上传组件需要的样式 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
